/*eslint-disable*/
import React from 'react'
import ServicesCard from './ServicesCard'
import { businessData } from './data'
import { Link } from 'react-router-dom'

const ServicesBusiness = () => {
  return (
    <div className='flex items-start flex-wrap mt-20 px-4 sm:px-5 lg:px-10'>
      <div className='w-full sm:w-1/2 md:w-1/3 pb-4 md:pr-12'>
        <h1 className='text-left text-4xl sm:oya-ghana-header-h3 md:text-5xl font-bold leading-tight'>
          Services we <br /> Offer?
        </h1>
        <p className='my-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0'>
          Oya Ghana offers a wide range of services which includes:
        </p>
      </div>

      <div className='w-full sm:w-1/2 md:w-2/3'>
        <div className='w-full grid sm:md:grid-cols-2 md:grid-cols-2 gap-6'>
          {businessData.map((business) => {
            return (
              <Link to={`/service/${business.slug}`}>
                <ServicesCard business={business} />
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ServicesBusiness
